import React, { Component } from "react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import Table from "../../components/common/table";
import Like from "../../components/common/like";
import Delete from "../../components/common/delete";
import AccountEnabled from "../../components/common/accountenabled";

class AccountsTable extends Component {
  columns = [
    // {
    //   path: "id",
    //   label: "#",
    //   content: account => <Link to={`/accounts/${account.username}`}>{account.id}</Link>
    // },
    // {
    //   key: "enableuser",
    //   content: account => (
    //     <AccountEnabled enableuser={account.enableuser} />
    //   )
    // },
    {
      key: "enableuser",
      content: account => (
        <AccountEnabled enableuser={account.enableuser} isOnline={account.isOnline} />
      )
    },
    { path: "username", label: "Username",
      content: account => (
        <Link
          to={{
            pathname: `/accounts/${account.username}`,
            state: { filters: this.props.filters }
          }}
        >
          {account.username}
        </Link>
      )
    },
    { path: "service", label: "Service" },
    { path: "expires", label: "Expiration" },
    { path: "expiration", label: "Expiry Date" },
  ];

  likeColumn = {
    key: "like",
    content: account => (
      <Like liked={account.liked} onClick={() => this.props.onLike(account)} />
    )
  }  

  deleteColumn = {
    key: "delete",
    content: account => (
      <Delete onClick={() => this.props.onDelete(account)} />
    )
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.role && user.role === "Manager") this.columns.push(this.likeColumn);
    if (user && user.role && user.role === "Administrator") this.columns.push(this.deleteColumn);
  }

  render() {
    const { accounts, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={accounts}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default AccountsTable;
